/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Shopping_Recipe_RemoveInputs */

const en_shopping_recipe_remove = /** @type {(inputs: Shopping_Recipe_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Take ${i?.title} off the list`)
};

const de_shopping_recipe_remove = /** @type {(inputs: Shopping_Recipe_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} von der Liste nehmen`)
};

/**
* | output |
* | --- |
* | "Take {title} off the list" |
*
* @param {Shopping_Recipe_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_recipe_remove = /** @type {((inputs: Shopping_Recipe_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Recipe_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_recipe_remove(inputs)
	return en_shopping_recipe_remove(inputs)
});